import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Badge } from '../ui/badge';
import { GripVertical, Factory } from 'lucide-react';

function ProcessStepCard({
  step,
  productName,
  plannedQuantity,
  orderId,
  orderNumber,
  itemId,
  itemIndex,
  productCode,
  completedQuantity = 0,
  isOverlay = false,
  isSubcontracted = false,
}) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `unassigned-step-${orderId}-${itemId}-${step.sequence}`,
    disabled: isSubcontracted,
    data: {
      type: 'unassigned-step',
      orderId,
      orderNumber,
      itemId,
      itemIndex,
      productCode,
      productName,
      plannedQuantity,
      stepSequence: step.sequence,
      stepName: step.name,
      standardTime: step.standard_time,
      completedQuantity,
      isSubcontracted,
      step,
    },
  });

  const style = transform
    ? { transform: CSS.Translate.toString(transform) }
    : undefined;

  if (isSubcontracted) {
    return (
      <div
        ref={setNodeRef}
        className="p-2 mb-1.5 bg-gray-50 border border-gray-200 rounded-md opacity-60 cursor-not-allowed"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <Factory className="h-3 w-3 text-gray-400" />
            <span className="text-xs font-medium text-gray-500">{step.name}</span>
          </div>
          <Badge variant="secondary" className="text-[10px] h-4 px-1">已外协</Badge>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`
        p-2 mb-1.5 bg-white border rounded-md cursor-grab active:cursor-grabbing
        transition-shadow hover:shadow-md
        ${isDragging || isOverlay ? 'shadow-lg ring-2 ring-blue-400 opacity-90' : 'border-gray-200'}
      `}
    >
      <div className="flex items-center gap-1">
        <GripVertical className="h-3 w-3 text-gray-400 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-1">
            <span className="text-xs font-semibold text-gray-800 truncate">{step.name}</span>
            <span className="text-[10px] text-gray-400 shrink-0">{step.standard_time}分</span>
          </div>
          <div className="text-[10px] text-gray-500 truncate">{productName || productCode}</div>
          <div className="text-[10px] text-gray-500">
            数量: {plannedQuantity - completedQuantity}
            {completedQuantity > 0 && <span className="text-gray-400"> (已完成{completedQuantity})</span>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessStepCard;
